<template>
  <div
    class="container1"
    v-wechat-title="$store.state.region.re_name + '-大赛-报名'"
  >
    <div class="backtop">
      <img @click="back" src="@/assets/images/back_bai.png" alt="" />
      <span>{{ this.$route.params.title }}报名</span>
    </div>
    <div class="center_baoming">
      <!-- <h2>{{this.$route.params.title}}</h2> -->
      <!-- <div class="pot">
            <div class="baishe">
                <img src="@/assets/images/baoming/paishe.png" alt="">
            </div>
        </div> -->
      <div class="shanghcuan">
        <van-uploader
          v-if="this.$route.params.type == 1"
          v-model="fileList"
          :after-read="afterRead"
          :before-delete="befores"
          :max-count="9"
          :preview-size="110"
        />
        <van-uploader
          v-else-if="this.$route.params.type == 4"
          v-model="fileList"
          :after-read="afterRead"
          :before-delete="befores"
          :max-count="9"
          :preview-size="110"
        />
        <div v-else>
          <div class="videoClick">
            <img src="@/assets/images/shipin.png" alt="" />
            <input
              @change="videoChange"
              type="file"
              accept="video/*"
              id="file_btn"
            />
            <span @click="delelt" v-show="flagVideos">×</span>
            <video
              v-show="flagVideos"
              class="videos"
              id="1"
              :src="videoDtail.cover_path"
              controls
            ></video>
          </div>
        </div>
      </div>
      <div class="adddata">
        <div class="adddataList">
          <div class="left">
            <img src="@/assets/images/baoming/zuopin.png" alt="" />
            <span>作品标题</span>
          </div>
          <input
            v-model="addressData.signup_theme_name"
            class="right"
            type="text"
            placeholder="请输入您的作品名称"
          />
        </div>
        <div class="adddataList" v-if="this.$route.params.type != 4">
          <div class="left">
            <img src="@/assets/images/baoming/didian.png" alt="" />
            <span>拍摄地点</span>
          </div>
          <input
            v-model="addressData.shoot_site"
            class="right"
            type="text"
            placeholder="请输入您的拍摄地点"
          />
        </div>
        <div class="adddataList">
          <div class="left">
            <img src="@/assets/images/baoming/shuming.png" alt="" />
            <span>作者署名</span>
          </div>
          <input
            v-model="addressData.signup_username"
            class="right"
            type="text"
            placeholder="请输入您的作者署名"
          />
        </div>
        <div class="adddataList">
          <div class="left">
            <img src="@/assets/images/baoming/mingcheng.png" alt="" />
            <span>作品简介</span>
          </div>
          <!-- <input v-model="addressData.signup_username" class="right" type="text" placeholder="请输入您的作品简介" /> -->
          <van-field
            v-model="addressData.signup_dec"
            rows="2"
            autosize
            type="textarea"
            maxlength="50"
            placeholder="请输入您的作品简介"
            show-word-limit
          />
        </div>
        <p class="jingao">(以下信息为参赛要求非公开，仅主办方收到)</p>
        <div class="adddataList">
          <div class="left">
            <img src="@/assets/images/baoming/xingming.png" alt="" />
            <span>真实姓名</span>
          </div>
          <input
            @blur="dname(addressData.signup_true_name)"
            v-model="addressData.signup_true_name"
            class="right"
            type="text"
            placeholder="请输入您的真实姓名"
          />
        </div>
        <div class="adddataList">
          <div class="left">
            <img src="@/assets/images/baoming/qiye.png" alt="" />
            <span>通讯地址</span>
          </div>
          <!-- <input class="right" type="text" placeholder="请输入您的通讯地址" /> -->
          <van-field
            v-model="addressData.signup_address"
            rows="2"
            autosize
            type="textarea"
            maxlength="50"
            placeholder="请输入您的通讯地址"
            show-word-limit
          />
        </div>
        <div class="adddataList">
          <div class="left">
            <img src="@/assets/images/baoming/shouji.png" alt="" />
            <span>联系手机</span>
          </div>
          <input
            @blur="dphone(addressData.signup_phone)"
            v-model="addressData.signup_phone"
            class="right"
            type="number"
            placeholder="请输入您的手机号码"
          />
        </div>
        <div class="adddataList">
          <div class="left" style="width: 76px; height: 40px">
            <span></span>
          </div>
          <input
            v-model="addressData.phone_code"
            class="right"
            type="text"
            placeholder="输入验证码"
          />
          <span class="pos" @click="time">{{ text }}</span>
        </div>
      </div>
    </div>
    <div class="tofrom" @click="tofrom">提交</div>
  </div>
</template>
<script>
</script>
<script>
import { xiaoxi, cansai, del_img } from "@/api/travel";
import $ from "jquery";
export default {
  data() {
    return {
      text: "获取验证码",
      flag: true,
      timer: null,
      flags: false,
      flagname: false,
      flagTi: true,
      flagVideo: true,
      addressData: {
        // 作品标题
        signup_theme_name: "",
        // 参赛图片
        signup_image: "",
        // 大赛主题的id
        shoot_id: "",
        // 拍摄位置
        shoot_site: "",
        // 作者署名
        signup_username: "",
        // 作品简介
        signup_dec: "",
        // 真实姓名
        signup_true_name: "",
        // 参赛预留手机号
        signup_phone: "",
        // 用户通讯地址
        signup_address: "",
        // 手机验证码
        phone_code: "",
        // 验证码对应的id
        phone_code_id: "",
        RegIdProvince: "1",
        RegIdCity: "",
        RegIdDistrict: "",
      },
      fileList: [],
      imgList: [],
      videoDtail: {},
      timer: null,
      flagVideos: false,
    };
  },
  methods: {
    // 姓名验证
    dname(val) {
      let name = /^[\u4e00-\u9fa5]{2,10}$/;
      if (!name.test(val)) {
        this.$toast("姓名格式错误");
        this.flagname = false;
      } else {
        return (this.flagname = true);
      }
    },
    dphone(val) {
      // 手机号验证规则
      let phone =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      // 判断是否有18位或者15位
      if (!phone.test(val)) {
        this.$toast("手机格式错误");
        return (this.flags = false);
      } else {
        return (this.flags = true);
      }
    },
    //提交
    tofrom() {
      this.addressData.RegIdCity = JSON.parse(
        localStorage.getItem("regionList")
      ).ParentID;
      this.addressData.RegIdDistrict = JSON.parse(
        localStorage.getItem("regionList")
      ).id;
      // this.addressData.phone_code_id = 79;
      // this.addressData.phone_code = 436552;
      // console.log(this.addressData);
      if (this.$route.params.type == 1 || this.$route.params.type == 4) {
        // if(this.$route.params.type == 4){
        //   delete this.addressData.shoot_site
        // }
        let arr = [];
        this.imgList.forEach((v) => {
          arr.push(v.path);
        });
        this.addressData.signup_image = arr.join("#");
        this.addressData.shoot_id = this.$route.params.id;
        if (
          this.flags &&
          this.flagname &&
          this.addressData.signup_theme_name &&
          this.addressData.signup_image &&
          this.addressData.signup_username &&
          this.addressData.signup_dec &&
          this.addressData.signup_true_name &&
          this.addressData.signup_phone &&
          this.addressData.signup_address &&
          this.addressData.phone_code
        ) {
          this.$dialog
            .confirm({
              title: "标题",
              message: "确认参赛吗?",
            })
            .then(() => {
              cansai(this.addressData).then((res) => {
                // console.log(res);
                this.flagTi = false;
                this.flagVideo = false;
                this.$toast("提交成功,请等待审核");
                // this.$router.push({
                //   name: "CompetitionDetail",
                //   params: { type: this.$route.params.type, id: this.$route.params.id },
                // });
                this.$router.back();
              });
            })
            .catch(() => {});
        } else {
          this.$toast("提交失败");
        }
      } else if (this.$route.params.type == 2) {
        this.addressData.signup_image = this.videoDtail.path;
        this.addressData.shoot_id = this.$route.params.id;
        console.log(this.addressData);
        // console.log(this.addressData);
        if (
          this.flags &&
          this.flagname &&
          this.addressData.signup_theme_name &&
          this.addressData.signup_image &&
          this.addressData.shoot_id &&
          this.addressData.shoot_site &&
          this.addressData.signup_username &&
          this.addressData.signup_dec &&
          this.addressData.signup_true_name &&
          this.addressData.signup_phone &&
          this.addressData.signup_address &&
          this.addressData.phone_code
        ) {
          this.$dialog
            .confirm({
              title: "标题",
              message: "确认参赛吗?",
            })
            .then(() => {
              cansai(this.addressData).then((res) => {
                console.log(res);
                this.flagTi = false;
                this.flagVideo = false;
                // this.$toast({
                //   // duration: 3000, // 持续展示 toast
                //   forbidClick: true,
                //   message: "提交成功,请等待审核",
                // });
                this.$toast("提交成功,请等待审核");
                // setTimeout(() => {
                // this.$router.push({
                //   name: "CompetitionDetail",
                //   params: { type: 2, id: this.$route.params.id },
                // });
                this.$router.back();
                // }, 2000);
              });
            })
        } else {
          this.$toast("提交失败");
        }
      }
    },
    //视频上传
    videoChange(e) {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "",
      });
      toast.message = `上传中,请耐心等待`;
      // 此时可以自行将文件上传至服务器
      let formData = new FormData(); /*创建formData对象*/
      // //Base64字符串转二进制
      console.log(this.$route.params.type);
      formData.append("type", this.$route.params.type);
      formData.append("coverimg", e.target.files[0]);
      this.$http
        .post("/index.php/api/travel/upload_img", formData)
        .then((res) => {
          this.$toast("上传成功");
          this.videoDtail = res.data.data;
          this.flagVideos = true;
          //通过定时器来实时判断图片是否上传成功
          this.timer = setInterval(() => {
            if (res.data.data) {
              clearInterval(this.timer);
              this.$toast.clear();
            }
          }, 50);
        })
        .catch((err) => {
          this.$toast("上传失败");
        });
    },
    // 视频删除
    delelt() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否删除此视频?",
        })
        .then(() => {
          this.$toast.loading({
            message: "删除中...",
            forbidClick: true,
          });
          del_img({
            type: 1,
            img_name: this.videoDtail.path,
          }).then((res) => {
            console.log(res);
            this.videoDtail = {};
            this.flagVideos = false;
            this.$toast("删除成功");
          });
        })
        .catch(() => {});
    },
    back() {
      this.$router.back();
    },
    //图片上传
    afterRead(file) {
      this.$toast.loading({
        message: "上传中...",
        forbidClick: true,
      });
      // 此时可以自行将文件上传至服务器
      let formData = new FormData(); /*创建formData对象*/
      console.log(this.$route.params.type);
      formData.append("type", this.$route.params.type);
      formData.append("coverimg", file.file);
      this.$http
        .post("/index.php/api/travel/upload_img", formData)
        .then((res) => {
          this.$toast("上传成功");
          this.imgList.push({
            cover_path: res.data.data.cover_path,
            path: res.data.data.path,
          });
          this.$toast.clear();
        }).catch((err) => {
              this.$toast("上传失败");
              file.status = 'failed';
              file.message = '上传失败';
          });
    },
    //删除图片
    befores(e, flie) {
      if(e.status == "failed"){
        this.fileList.splice(flie.index, 1);
        this.imgList.splice(flie.index, 1);
        return
      }
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否删除此图片?",
        })
        .then(() => {
          this.$toast.loading({
            message: "删除中...",
            forbidClick: true,
          });
          del_img({
            type: 1,
            img_name: this.imgList[flie.index].path,
          }).then((res) => {
            // console.log(res);
            this.fileList.splice(flie.index, 1);
            this.imgList.splice(flie.index, 1);
            this.$toast("删除成功");
          });
        })
        .catch(() => {});
    },
    //验证码
    time() {
      if (this.flag && this.addressData.signup_phone && this.flags) {
        this.$toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
        xiaoxi({ phone: this.addressData.signup_phone }).then((res) => {
          this.addressData.phone_code_id = res.code_data.code_id;
          this.flag = false;
          let num = 60;
          this.timer = setInterval(() => {
            this.$toast.clear();
            if (num == 0) {
              this.text = "获取验证码";
              this.flag = true;
              clearInterval(this.timer);
              return;
            }
            this.text = num + "s";
            num--;
          }, 1000);
        });
      }
    },
  },
  mounted() {
    this.$nextTick(() => {});
  },
  created() {},
  beforeDestroy() {
    if (this.imgList.length > 0 && this.flagTi) {
      //页面销毁时删除多张图片
      let arr = [];
      this.imgList.forEach((v) => {
        arr.push(v.path);
      });
      del_img({
        type: 2,
        img_name: arr.join("#"),
      }).then((res) => {
        // console.log(res);
      });
    } else if (this.videoDtail.path && this.flagVideo) {
      del_img({
        type: 2,
        img_name: this.videoDtail.path,
      }).then((res) => {
        console.log(res);
      });
    }
  },
};
</script>
<style scoped>
#file_btn {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  cursor: pointer;
  opacity: 0;
}
.videoClick {
  width: 95vw;
  height: 200px;
  background-color: #f7f8fa;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  position: relative;
}
.videoClick img {
  width: 50px;
  height: 50px;
}
.videoClick span {
  width: 30px;
  height: 30px;
  position: absolute;
  font-size: 0.8rem;
  color: #fff;
  background-color: red;
  border-radius: 50%;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 8;
}
.videoClick video {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
}
.backtop {
  background-color: #e95b2d;
  line-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  padding-right: 20px;
  position: relative;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9;
}
.backtop span {
  color: #fff;
}
.backtop img {
  position: absolute;
  left: 10px;
  width: 30px;
  height: 30px;
}
.center_baoming {
  background-color: #fff;
  padding-top: 44px;
  padding-bottom: 100px;
}
.center_baoming h2 {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  background-color: #fff;
  border-bottom: 1px solid #eeeeee;
  margin: 0 10px;
}
.baishe {
  width: 33.3%;
  height: 100px;
  border: 1px solid #f2bf96;
  display: flex;
  align-items: center;
  justify-content: center;
}
.baishe img {
  width: 30px;
  height: 30px;
}
.adddataList img {
  width: 14px;
  height: 16px;
  margin-right: 6px;
}
.adddata {
  padding: 0 12px;
}
.adddataList {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #e5e5e5;
  line-height: 40px;
  position: relative;
  padding: 0 20px;
}
.adddataList:first-child {
  border-top: 1px solid #e5e5e5;
}
.adddataList .left {
  margin-right: 10px;
  color: #ea6a00;
  font-size: 14px;
  min-width: 90px;
  display: flex;
  align-items: center;
}
.van-cell {
  padding-left: 0;
}
.adddataList input {
  font-size: 14px;
}
.pos {
  position: absolute;
  right: 10px;
  background-color: #fff;
  color: #ea6a00;
  font-size: 14px;
}
.tofrom {
  width: 40%;
  background-color: #ea6a00;
  position: fixed;
  bottom: 10px;
  left: 50%;
  right: 0;
  line-height: 40px;
  text-align: center;
  transform: translateX(-50%);
  color: #fff;
  border-radius: 20px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
}
.right {
  flex: 1;
}
.jingao {
  display: flex;
  font-size: 12px;
  justify-content: center;
  margin: 2px 0;
}
.shanghcuan {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}
</style>